<template>
    <transition name="fade">
        <div role="alert" :class="typeClass" v-if="alert" @click="alert = false">
            <div class="v-alert__wrapper">
                <i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-check-circle theme--dark"></i>
                <div class="v-alert__content">
                    {{ content }}
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    name: 'Alert',
    data: () => ({
        alert: true,
        baseClass :'v-alert v-sheet theme--dark '
    }),
    props :[
        'content',
        'type'
    ],
    computed:{
        alertIcon(){
            switch (this.type) {
                case "success":
                    return "mdi-home"
                    break;
                case "info":
                    return "mdi-information"
                    break;
                case "warning":
                    return "mdi-exclamation"
                    break;
                case "error":
                    return "mdi-alert"
                    break;
                default:
                    return ""
                    break;
            }
        },
        typeClass(){
            return this.baseClass + this.type;
        }
    },
    mounted(){
        setTimeout(()=>{
            this.alert = false;
        },5000)
    }
}
</script>

<style scoped>
    a {  text-decoration: none;}
    .active div i{
        color: #ff4081 !important;
        caret-color: #ff4081 !important;
    }
    .logout-btn{
        margin-left: 5px;
    }
    .home-btn{
        cursor: pointer;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>